import { createContext, useState } from "react";

const MeetingContext = createContext()


function MeetingProvider({ children }) {

    const [meetingData, setMeetingData] = useState(null)
    return (
        <MeetingContext.Provider value={{ meetingData, setMeetingData }}>
            {children}
        </MeetingContext.Provider>
    )
}

export { MeetingContext, MeetingProvider }